module.exports = __webpack_public_path__ + "media/portal hypertensive gastropathy.18c7ffb2.wav";